import { useTranslation } from "react-i18next";
import { Group, Pagination,Text } from "@mantine/core";

import { Pagination as PaginationType } from "@customTypes/index";


interface TablePaginationProps {
  onPageChange: (page: number) => void;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  isLoading?: boolean;
  paginationData: Partial<PaginationType>;
  paginatedRows: number;
}

export const TablePagination = ({
  paginationData,
  paginatedRows,
  onPageChange,
  size = "sm",
  isLoading = false,
}: TablePaginationProps) => {
  const { t } = useTranslation();

  if (!paginationData.total || paginationData.total === 0) {
    return null;
  }

  return (
    <Group justify="space-between" align="center" mt="md" wrap="wrap" gap="md">
      <Text fz={14} c="dimmed">
        {t("displaying-x-rows", {
          paginatedRows,
          totalRows: paginationData.total,
        })}
      </Text>

      <Pagination
        total={paginationData?.pageCount || 0}
        value={paginationData?.page || 1}
        onChange={onPageChange}
        size={size}
        withEdges
        disabled={isLoading}
      />
    </Group>
  );
};
